import axios from '../../axiosAuthen';

const checkPermission = async (header) => {

    try {

        const currentURL = window.location.href;
        const url = new URL(currentURL);
        const domain = url.origin;
        const link = url.pathname;

        const result = await axios({
            url: '/public/list-action',
            method: 'GET',
            params: {
                domain,
                link,
            },
            headers: header
        });

        if (result.status !== 200) {

            if(result.status === 401) {
                return {
                    hasService: false,
                    hasPermission: false,
                    message: result.message,
                    action: [],
                };
            } else {
                return {
                    hasService: true,
                    hasPermission: false,
                    message: result.message,
                    action: [],
                };
            }

        }
        return {
            hasService: true,
            hasPermission: true,
            message: result.message,
            action: result.data,
        };
    } catch (error) {
        console.log(error);
        return {
            hasService: true,
            hasPermission: true,
            message: 'Hệ thống đang bảo trì.',
            action: [],
        };
    }
};

export { checkPermission };
